<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <WIN_scondHero />
        <WIN_highLights :clientWidth="clientWidth"/>
        <WIN_twoTout />

        <div>WindowStore</div>


    </main>

</template>


<script>
    import WIN_scondHero from "../../components/content/enterprise/overView/WIN_scondHero";
    import WIN_highLights from "../../components/content/enterprise/overView/WIN_highLights";
    import WIN_twoTout from "../../components/content/enterprise/overView/WIN_twoTout";


    export default {
        name: 'WindowStore',
        components: {
            WIN_scondHero,
            WIN_highLights,
            WIN_twoTout,
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {

            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methoWIN: {

        }

    }
</script>

<style>


</style>
